import { OpenQuoteModel } from "../../core";
import { EsignModel } from "../../core/models/esign.model";

export function quoteHasPlan(quote?: OpenQuoteModel) {
  return quote?.member?.firstName && quote?.planId && quote?.plans.find((x) => x.identifier === quote.planId);
}

export function hasActiveEsignInfo(esignInfo?: EsignModel | null) {
    return esignInfo?.caseId && !esignInfo?.isExpired;
}